import React from 'react';

/**
 * Context properties
 * */
export default React.createContext();
